export default {
  "fr": {
    "survey": {
      "actions": {
        "add": "Ajouter",
        "close": "Fermer",
        "create": "Créer",
        "delete": "Supprimer",
        "deleteCount": "Vous êtes sur le point de supprimer {count} enquête. Êtes-vous sûr? | Vous êtes sur le point de supprimer {count} enquêtes. Êtes-vous sûr?",
        "deleteMultiple": "Supprimer...",
        "delete_cancel": "Annuler",
        "delete_surveys": "Supprimer enquête | Supprimer enquêtes",
        "newSurvey": "Nouvelle Enquête",
        "publish": "Publier",
        "publishCustomer": "Publier pour vos clients",
        "save": "Enregister",
        "selectAll": "Sélectionner tous les {total} enquêtes",
        "submit": "Soumettre",
        "surveys_collapse": "Réduire les enquêtes",
        "surveys_expand": "Élargir les enquêtes",
        "unSelectAll": "Effacer la sélection",
        "unpublish": "Annuler la publication"
      },
      "attributes": {
        "description": "Titre interne",
        "title": "Votre question"
      },
      "labels": {
        "NPSOverview": "La vue d'ensemble du NPS",
        "NPSQuestion": "Quelle est la probabilité que vous recommandiez {name} à vos amis et à votre famille?",
        "addQuestion": "Ajouter une question",
        "allUnitsAssigned": "Toutes les unités ont été assignées",
        "answer_later": "Répondre plus tard",
        "answeredAt": "Répondu à",
        "average_score": "Score moyen",
        "clientTeam": "L'équipe {name}",
        "comments": "Commentaires ou suggestions? (facultatif)",
        "completedTime": "Date",
        "customer": "Client",
        "customer_status": "Statut",
        "detractors": "Détracteurs",
        "dissatisfied": "Insatisfait",
        "extremelyLikely": "Extrêmement probable",
        "lets_go": "Allons-y",
        "list": "La relève",
        "neither_satisfied_nor_dissatisfied": "Ni satisfait ni insatisfait",
        "neutrals": "Neutres",
        "noSurveyFeedback": "Pas de commentaires ou de suggestions",
        "noUnitsClick": "Pas encore d'unités, cliquer ici pour ajouter",
        "no_opinion": "Pas d'opinion",
        "notAtAllLikely": "Pas du tout probable",
        "nps": "NPS",
        "numberAnswered": "{answered} réponses sur {total}",
        "obligatory": "Rendre l'enquête obligatoire pour les clients",
        "pendingSurveys": " 1 enquête à laquelle répondre | {count} enquêtes auxquels répondre",
        "promoters": "Promoteurs",
        "publishNow?": "Publier maintenant?",
        "publishedCount": "Publier cette enquête sur le client | Publier {count} enquêtes sur le client",
        "question": "Question",
        "question_number": "Question {current_number} sur {total_questions}",
        "questions": "Questions",
        "respondents": "Aucun répondant | 1 repondant | {count} répondants",
        "response": "Réponse",
        "responses": "Réponses",
        "satisfied": "Satisfait",
        "saveExplainer": "Voulez-vous rendre cette enquête visible pour vos clients immédiatement? Ou préférez-vous l'enregistrer d'abord et la plublier plus tard?",
        "scoreBreakdown": "La repartition du score",
        "selectOneUnit": "Sélectionnez au moins 1 enquête",
        "selectUnits": "Selectionner les unités",
        "selected": "{selected} enquête est sélectionnée. | {selected} enquêtes sont sélectionnées",
        "showSurveysFor": "Afficher les enquêtes pour",
        "showingResultsFor": "Montrer les résultats pour",
        "step2Subtitle": "De cette façon, vos clients sauront mieux quel est le but de cette enquête",
        "step2Title": "Ajouter une courte introduction",
        "step3Subtitle": "Sélectionnez votre projet pour inclure toutes vos unités à la fois.",
        "step3Title": "Pour quelles unités souhaitez-vous créer cette enquête?",
        "survey": "Enquête",
        "surveyAlreadyAnswered": "L'enquête a déjà été répondu. Merci pour vos commentaires.",
        "surveyAnswer": "Commentaire",
        "surveyNotCompleted": "L'enquête n'est pas encore terminé",
        "surveys": "Enquêtes",
        "surveysCount": "{count} enquête | {count} enquêtes",
        "thankYou": "Merci pour vos commentaires",
        "title": "Question",
        "titles_must_be_unique": "Il y a des questions en double. Les questions doivent être uniques!",
        "totalSelected": "Touts les {count} enquêtes sont sélectionnés",
        "unit": "Unité",
        "unitSelected": "Aucune unité à été sélectionnée pour le moment | Une unité sélectionnée | {count} unités sélectionnées",
        "units": "Unités",
        "unitsWithoutSurvey": "{count} unité sans enquête | {count} unités sans enquêtes.",
        "unpublishedCount": "Annuler la publication de cette enquête | Annuler la publication de {count} enquêtes",
        "very_dissatisfied": "Très insatisfait",
        "very_satisfied": "Très satisfait",
        "visibility": "Visibilité",
        "yourQuestion": "Votre question"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Demandez votre clients pour leurs commentaires",
            "title": "Créez votre premier enquête"
          },
          "none": {
            "subtitle": "Demandez votre clients pour leurs commentaires",
            "title": "Aucun enquête trouvé"
          }
        }
      },
      "toasts": {
        "bulk_create": "Enquête a été créé avec succès | Enquêtes créés avec succès",
        "bulk_delete": "Enquête a été supprimé avec succès | Enquêtes supprimés avec succès",
        "bulk_update": "Enquête a été mise à jour avec succès | Enquêtes mises à jour avec succès",
        "update": "Enquête mise à jour avec succès"
      },
      "validation": {
        "needName": "Entrer une question",
        "selectUnit": "Sélectionner au moins 1 unité"
      }
    }
  }
}